export default __webpack_public_path__ + "assets/loading.698d239f7b0c4fa1b25d1aaaae1dc745.gif";